import React from 'react';
import {Link, StyleSheet, Text, View} from "@react-pdf/renderer";
import styled from '@react-pdf/styled-components';

// Create styles
const styles = StyleSheet.create({
        textlist: {
                color: '#666666',
                margin: '2px 20px 0 30px',
                fontSize: 10,
                fontFamily: 'TTNorms',
                width:555,
        }
});

// const Heading = styled.Text`
//   margin: 100px 20px 0 20px;
//   font-size: 22px;
//   font-family: 'PTSans';
// `;

const ModuleContentTop = styled.Text`
  color: #333333;
  margin: 60px 20px 0 20px;
  font-size: 10px;
  font-family: 'TTNorms';
  width:555px;
`;

const ModuleContent = styled.Text`
  color: #333333;
  margin: 8px 20px 0 20px;
  font-size: 10px;
  font-family: 'TTNorms';
  width:555px;
`;
const ModuleContent2 = styled.Text`
  color: #333333;
  margin: 2px 20px 0 20px;
  font-size: 10px;
  font-family: 'TTNorms';
  width:555px;
`;

// const ModuleContentBold = styled.Text`
//   color: #000000;
//   margin: 8px 20px 0 20px;
//   font-size: 10px;
//   font-family: 'PTSans';
//   width:555px;
// `;
// const ModuleContentBold2 = styled.Text`
//   color: #000000;
//   margin: 2px 20px 0 20px;
//   font-size: 10px;
//   font-family: 'PTSans';
//   font-weight: bold;
//   width:555px;
// `;
// const ModuleContentItalic = styled.Text`
//   color: #000000;
//   margin: 8px 20px 0 20px;
//   font-size: 10px;
//   font-family: 'PTSans';
//   //font-style: 'italic';
//   width:555px;
// `;
const ModuleTitle = styled.Text`
  color: #000000;
  margin: 12px 20px 0 20px;
  font-size: 14px;
  font-family: 'TTNorms';
`;

const About = () => (
    <View>
        <ModuleContentTop>
                GovernWith is so much more than just an evaluation platform. We provide the full circle of programs required
                to truly review and fully develop Boards as well as individual Directors.
        </ModuleContentTop>
        <ModuleContent>
                Together with our partners we expertly support Boards, Directors and whole organisations on their journey of continuous
                improvement; building a shared, consistent understanding of good governance; and empowering leaders to improve
                organisational efficiency, productivity, service quality and culture.
        </ModuleContent>
        <ModuleContent>
                The power of our success comes from evaluation being done year in year out, resulting in trended and benchmarked data. This
                informs the efficacy of governance decision making about both strategic and risk matters.
        </ModuleContent>
        <ModuleContent>
                By providing this variety of programs for review and development for whole Boards and Councils as well as individual Directors
                and Councillors, we are able to have a unique multi-dimensional view that previously hasn’t existed.
        </ModuleContent>
        <ModuleTitle>Governance Evaluation</ModuleTitle>
        <ModuleContent>
                In order to build capabilities, it’s important to understand where you are today. The questionnaire focuses on 9 key areas of
                corporate and sector specific governance:
        </ModuleContent>
        <Text style={styles.textlist}>&bull; Strategic Direction</Text>
        <Text style={styles.textlist}>&bull; Risk Management and Compliance</Text>
        <Text style={styles.textlist}>&bull; Continuous Review and Development</Text>
        <Text style={styles.textlist}>&bull; Governance Relations</Text>
        <Text style={styles.textlist}>&bull; Board Composition</Text>
        <Text style={styles.textlist}>&bull; Board Processes</Text>
        <Text style={styles.textlist}>&bull; Finance</Text>
        <Text style={styles.textlist}>&bull; Key Stakeholder Engagement</Text>
        <Text style={styles.textlist}>&bull; Sector and Organisation Specific Modules</Text>
        <ModuleContent>
                As a part of the Board Evaluation process we create personalised reports, documentation and data insights required for
                industry internal and external accreditation and assessment, that are trended and benchmarked. Building on from the results
                of the evaluation we support boards to build and measure tailored action plans support by our extensive library of resources
                or we can direct you to our partners expert resources and support services.
        </ModuleContent>
        <ModuleTitle>Director Development and Skills Matrix</ModuleTitle>
        <ModuleContent>
                The Development & Skills Matrix questionnaire assesses both individual Directors and the whole Board for governance and
                sector-specific skills. This is critical as Boards must not only understands their roles and responsibilities for governance, but
                must also be assured that it is comprised of Directors who collectively have the skills, knowledge and experience to
                effectively understand the business they are governing.
        </ModuleContent>
        <ModuleContent>
                The questionnaire is structured into the following modules:
        </ModuleContent>
        <Text style={styles.textlist}>&bull; Professional Director Skills</Text>
        <Text style={styles.textlist}>&bull; Sector or Organisation Specific Skills</Text>
        <Text style={styles.textlist}>&bull; Culture</Text>
        <Text style={styles.textlist}>&bull; Contribution</Text>
        <Text style={styles.textlist}>&bull; Governance Development</Text>
        <ModuleTitle>
                And that’s just the beginning...
        </ModuleTitle>
        <ModuleContent>
                For a no obligation discussion about any governance requirements, please call us on <Link src={'tel:0488525460'}>0488 525 460</Link> or contact us by email at
        </ModuleContent>
        <ModuleContent2>
            <Link src={'mailto:solutions@governwith.us'}>solutions@governwith.us</Link>. For more information, visit our website <Link src={'https://governwith.us'}>governwith.us</Link>
        </ModuleContent2>
    </View>
);

export default About;
